var EndOfImageMarker = {
  name: function name() {
    return "EOI";
  }
};
export default EndOfImageMarker;